/**
 * SEO 配置 - models (Polski)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Generator wideo AI zgodny z fizyką | WeryAI',
        description: 'Generuj realistyczne filmy AI zgodne z prawami fizyki za pomocą OpenAI Sora 2 ze zsynchronizowanym dźwiękiem i spójnością narracji.',
        keywords: 'Sora 2, OpenAI Sora, model wideo AI, realistyczne wideo AI, tekst na wideo, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 | WeryAI',
        description: 'Experience WeryAI Image 2.0 on WeryAI.',
        keywords: 'WeryAI Image 2.0, AI, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 | xAI | WeryAI',
        description: 'Experience Grok-2 by xAI on WeryAI.',
        keywords: 'Grok-2, xAI, AI, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Kinowy generator wideo AI | WeryAI',
        description: 'Kling 2.5 Turbo tworzy kinowe filmy AI wysokiej jakości z zaawansowaną kontrolą obiektywu, ekspresją emocjonalną i płynną fizyką ruchu.',
        keywords: 'Kling 2.5 Turbo, Kling AI, kinowe wideo AI, kontrola obiektywu AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - Zaawansowany generator i edytor wideo AI | WeryAI',
        description: 'Runway Gen-4 generuje realistyczne i spójne filmy AI z głębszym zrozumieniem promptów i inteligentnymi narzędziami do edycji. Wypróbuj za darmo na WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, generator wideo AI, tekst na wideo, obraz na wideo, edycja wideo AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Generator wideo AI Hailuo - zaawansowane tworzenie wideo | WeryAI',
        description: 'Generuj zaawansowane filmy AI za pomocą Hailuo AI w WeryAI. Najnowocześniejsza kontrola ruchu i realistyczne renderowanie scen.',
        keywords: 'Hailuo AI, MiniMax, generator wideo AI, kontrola ruchu, realistyczne wideo, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Generator wideo Seedance AI - Tworzenie tańca i ruchu | WeryAI',
        description: 'Generator wideo Seedance AI - Tworzenie tańca i ruchu on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro Generowanie obrazów | WeryAI',
        description: 'Nano Banana Pro - Google Gemini 3.0 Pro Generowanie obrazów na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'nano_banana_pro, AI, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Szybkie rysowanie Gemini 2.5 Flash | WeryAI',
        description: 'Google Nano Banana - Szybkie rysowanie Gemini 2.5 Flash na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'nano_banana, AI, WeryAI',
    },
    image_flux: {
        title: 'Generator obrazów FLUX AI - Najlepszy model rysunkowy Open Source | WeryAI',
        description: 'Generator obrazów FLUX AI - Najlepszy model rysunkowy Open Source na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'flux, AI, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Profesjonalne ulepszanie rysunków AI | WeryAI',
        description: 'FLUX.1 Kontext - Profesjonalne ulepszanie rysunków AI na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'flux_kontext, AI, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Zaawansowany model dyfuzyjny tekst na obraz od Google | WeryAI',
        description: 'Google Imagen 4 - Zaawansowany model dyfuzyjny tekst na obraz od Google na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'imagen, AI, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Model renderowania tekstu Open Source od Alibaba | WeryAI',
        description: 'Qwen Image - Model renderowania tekstu Open Source od Alibaba na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'qwen_image, AI, WeryAI',
    },
    image_wan_ai: {
        title: 'Generowanie obrazów Wan 2.5 - Model obrazów High Fidelity od Alibaba | WeryAI',
        description: 'Generowanie obrazów Wan 2.5 - Model obrazów High Fidelity od Alibaba na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - Model rysowania seryjnego 4K od ByteDance | WeryAI',
        description: 'Seedream 4.0 - Model rysowania seryjnego 4K od ByteDance na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'seendream, AI, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - Wszechstronny model tworzenia obrazów AI od ByteDance | WeryAI',
        description: 'Dreamina 4.0 - Wszechstronny model tworzenia obrazów AI od ByteDance na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'dreamina, AI, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - Flagowy Model Generacji Obrazów AI ByteDance | WeryAI',
        description: 'Seedream 4.5 to najnowszy flagowy model obrazów AI od ByteDance, skupiający się na precyzyjnym renderowaniu typografii i fuzji wielu obrazów z wyjściem 4K ultra HD. Wypróbuj za darmo na WeryAI.',
        keywords: 'Seedream 4.5, generacja obrazów AI, renderowanie typografii, fuzja obrazów, ByteDance, jakość 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Najlepsze rysowanie AI o estetyce artystycznej | WeryAI',
        description: 'Midjourney - Najlepsze rysowanie AI o estetyce artystycznej na WeryAI. Szybkie i wysokiej jakości wyniki.',
        keywords: 'midjourney, AI, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generator Wideo AI - Twórz Filmy Kinowe | WeryAI',
        description: 'Twórz niesamowite filmy z Runway Gen-4.5 na WeryAI. Hybrydowa architektura autoregresyjno-dyfuzyjna dla precyzyjnej symulacji fizyki i spójności czasowej.',
        keywords: 'Runway Gen-4.5, generator wideo AI, kinowe wideo AI, symulacja fizyki, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generator Wideo AI - Tworzenie Wysokiej Jakości Wideo | WeryAI',
        description: 'Generuj wysokiej jakości filmy z Kling 2.6 Pro na WeryAI. Natywna generacja audiowizualna, kinowa jakość 1080p, doskonałe przestrzeganie podpowiedzi.',
        keywords: 'Kling 2.6 Pro, generator wideo AI, wysokiej jakości wideo AI, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generator Wideo - Precyzyjna kontrola kamery i prowadzenie klatek | WeryAI',
        description: 'Generuj kinowe filmy AI z Dreamina 3.0 (Jimeng 3.0) na WeryAI. Precyzyjna kontrola klatek początkowych/końcowych, profesjonalne ruchy kamery i generowanie wideo 1080p o wysokiej dynamice.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generator wideo AI, kontrola kamery, klatki początkowe końcowe, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generator Wideo AI - Kreatywna Generacja Wideo | WeryAI',
        description: 'Uwolnij swoją kreatywność na WeryAI z generatorem wideo AI Kling O1. Idealny do tworzenia pomysłowej i unikalnej zawartości wideo.',
        keywords: 'Kling O1, generator wideo AI, kreatywne wideo AI, Kling AI, WeryAI',
    },
}
